/* Glow House — homepage helpers: tab switching for product rows ([data-gh-tabs]) and the brands A–Z index. */
(function () {
  if (window.GHHomeTabs) return;
  window.GHHomeTabs = true;

  function scopeOf(el) { return el.closest('[data-gh-tabs]'); }

  function select(tab, focus) {
    var scope = scopeOf(tab);
    if (!scope || tab.disabled) return;
    var id = tab.getAttribute('data-gh-tab');
    var tabs = scope.querySelectorAll('[data-gh-tab]');
    var panels = scope.querySelectorAll('[data-gh-panel]');
    var carousel = scope.matches('[data-carousel]') ? scope : null;

    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-gh-panel') === id;
      p.hidden = !on;
      if (carousel) {
        if (on) { p.setAttribute('data-carousel-track', ''); p.scrollLeft = 0; }
        else p.removeAttribute('data-carousel-track');
      }
    });
    if (focus) tab.focus();
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-gh-tabs] [data-gh-tab]');
    if (tab) select(tab, false);
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-gh-tabs] [data-gh-tab]');
    if (!tab) return;
    var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (keys.indexOf(e.key) === -1) return;
    var all = Array.prototype.filter.call(scopeOf(tab).querySelectorAll('[data-gh-tab]'), function (t) { return !t.disabled; });
    var i = all.indexOf(tab);
    var next;
    if (e.key === 'ArrowLeft') next = all[(i - 1 + all.length) % all.length];
    else if (e.key === 'ArrowRight') next = all[(i + 1) % all.length];
    else if (e.key === 'Home') next = all[0];
    else next = all[all.length - 1];
    if (next) { e.preventDefault(); select(next, true); }
  });

  /* Theme editor: when a tab block is selected, show its panel. */
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.matches && e.target.matches('[data-gh-tab]') ? e.target : null;
    if (tab) select(tab, false);
  });
})();
